import useCart from './useCart';
import { useCartRedux } from './useCart.redux';
import useFeature from './useFeature';

/**
 * Feature-flag-aware cart hook for the `payment-refactor` (revamp) UI.
 *
 * Returns the Redux cart when the `payment-refactor` flag is ON, otherwise the switched `useCart`.
 * Under the `complete-refactor` state layer both branches are Redux (JSAD-7433): the mapping that
 * used to live here is now `useCart.redux.ts`, so there is one Redux mapping instead of two and
 * the hybrid behaviour is unchanged.
 */
export const useCartRefactor = () => {
    const isRefactorEnabled = useFeature('payment-refactor', false);
    const reduxCart = useCartRedux();
    const zustandCart = useCart();

    return isRefactorEnabled ? reduxCart : zustandCart;
};

export default useCartRefactor;
